function stableHash(value) {
  const text = String(value ?? '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) - hash) + text.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

function collectMetaTokens(game) {
  const tokens = new Set();
  const push = (value) => {
    const text = String(value || '').trim().toLowerCase();
    if (text) tokens.add(text);
  };
  push(game?.badge);
  (Array.isArray(game?.tags) ? game.tags : []).forEach(push);
  (Array.isArray(game?.categories) ? game.categories : []).forEach(push);
  (Array.isArray(game?.categoryIds) ? game.categoryIds : []).forEach(push);
  return tokens;
}

function pushTag(tags, kind, label) {
  if (tags.some((tag) => tag.kind === kind)) return;
  tags.push(label ? { kind, label } : { kind });
}

const CATEGORY_BADGE_KINDS = new Set([
  'top', 'best', 'popular', 'hot', 'new', 'jackpot', 'vip', 'special', 'exclusive', 'retro', 'books',
]);

export function deriveCasinoCardTags(game) {
  const tags = [];
  const meta = collectMetaTokens(game);
  const hash = stableHash(game?.id ?? game?.name ?? '0');
  const maxWin = Number(
    game?.maxWin ?? game?.max_win ?? game?.maxMultiplier ?? game?.max_multiplier ?? game?.maxWinMultiplier ?? 0,
  );

  if (meta.has('new') || meta.has('yeni') || String(game?.badge || '').toLowerCase() === 'new') {
    pushTag(tags, 'new');
  }
  if (
    meta.has('tournament')
    || meta.has('turnuva')
    || String(game?.badge || '').toLowerCase() === 'tournament'
  ) {
    pushTag(tags, 'tournament');
  }
  if (meta.has('x50000') || meta.has('50000') || maxWin >= 50000) {
    pushTag(tags, 'x50000', 'x50000');
  } else if (meta.has('x15000') || meta.has('15000') || maxWin >= 15000) {
    pushTag(tags, 'x15000', 'x15000');
  }

  if (tags.length === 0) {
    const roll = hash % 8;
    if (roll === 0) pushTag(tags, 'new');
    else if (roll === 1 || roll === 2) pushTag(tags, 'x50000', 'x50000');
    else if (roll === 3 || roll === 4) pushTag(tags, 'x15000', 'x15000');
    else pushTag(tags, 'tournament');
  }

  const hasMult = tags.some((tag) => tag.kind === 'x50000' || tag.kind === 'x15000');
  const hasNew = tags.some((tag) => tag.kind === 'new');
  if ((hasMult || hasNew) && hash % 3 !== 0) {
    pushTag(tags, 'tournament');
  } else if (!tags.some((tag) => tag.kind === 'tournament') && !hasNew && hash % 5 !== 0) {
    pushTag(tags, 'tournament');
  }

  if (game?.freespin && !tags.some((tag) => tag.kind === 'fs')) {
    pushTag(tags, 'fs');
  }

  return tags;
}

export function isCategoryBadgeKind(kind) {
  return CATEGORY_BADGE_KINDS.has(String(kind || '').toLowerCase());
}
